import { forwardRef, createElement } from 'react';

function IconRatingBankruptcy(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm.035 4.982c-.264 0-.533.13-.533.51v.41C9.92 8.05 8.9 8.998 8.9 10.352c0 1.135.646 1.88 1.926 2.202l1.309.288c.844.181 1.178.44 1.178.879 0 .562-.446.931-1.272.931-.592 0-1.166-.246-1.687-.72-.334-.282-.545-.364-.803-.364-.416 0-.75.258-.75.715 0 .352.187.692.515.99.487.452 1.272.727 2.163.803v.358c0 .375.275.51.539.51.263 0 .533-.135.533-.51v-.37c1.64-.193 2.666-1.154 2.666-2.543 0-1.143-.66-1.862-1.997-2.176l-1.314-.273c-.744-.146-1.084-.427-1.084-.867 0-.492.44-.885 1.131-.885.586 0 1.008.188 1.506.662.293.252.533.364.85.364.369 0 .673-.27.673-.657 0-.328-.175-.673-.503-.984-.434-.422-1.131-.691-1.91-.79v-.423c0-.375-.27-.51-.534-.51z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var RatingBankruptcy = /*#__PURE__*/forwardRef(IconRatingBankruptcy);

export default RatingBankruptcy;
//# sourceMappingURL=RatingBankruptcy.js.map
